import { useEffect } from "react";
import { ToggleButton, DecimalInput } from "components";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveNextShoppingTripTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const start = useInput("7.00");
  const end = useInput("");
  const type = useInput("$");
  const isPurchase = useInput(true);
  const wType = useInput("");
  const wVal = useInput("");
  const suffix = useInput("");
  const typeData = [
    { label: "$", value: "$" },
    { label: "%", value: "%" },
  ];
  const typeData2 = [
    { label: "$", value: "$" },
    { label: "Unit", value: "Unit" },
  ];
  const formatValue = (s, e, t) => {
    if (!s) return "";
    return t === "$"
      ? `$${formatDollarValue(s)}${e ? `-$${formatDollarValue(e)}` : ""}`
      : `${s}${t}${e ? `-${e}${t}` : ""}`;
  };
  const handleUpdateValue = (s, e, t, isW, wv, wt, suf) => {
    onChange(
      `Save ${formatValue(s, e, t)} on next shopping visit${isW ? ` w/purchase${wt === "Unit" ? `/${wv}` : `/$${formatDollarValue(wv)}`}` : ``
      }${suf ? ` ${suf}` : ""}`
    );
  };

  useEffect(() => {
    if (value.toLowerCase().startsWith("save")) {
      let main = value.slice(4).trimStart();
      const nextIndex = main.indexOf("on next shopping visit");
      const vt = main.slice(0, nextIndex).trim();
      if (vt) {
        if (vt.startsWith("$")) {
          type.setValue("$");
          const parts = vt.split("-");
          start.setValue(parts[0].replace("$", "").trim());
          end.setValue(parts[1] ? parts[1].replace("$", "").trim() : "");
        } else if (vt.endsWith("%")) {
          type.setValue("%");
          const parts = vt.split("-");
          start.setValue(parts[0].replace("%", "").trim());
          end.setValue(parts[1] ? parts[1].replace("%", "").trim() : "");
        }
      } else {
        type.setValue("");
        start.setValue("");
        end.setValue("");
      }
      main = main.slice(nextIndex + 22).trimStart();
      if (main.startsWith("w/purchase/")) {
        isPurchase.setValue(true);
        main = main.slice(11).trimStart();
        const sufIndex = main.indexOf(" ");
        let wv = "";
        if (sufIndex > 0) {
          wv = main.slice(0, sufIndex).trim();
          suffix.setValue(main.slice(sufIndex + 1).trimStart());
        } else {
          wv = main.trim();
          suffix.setValue("");
        }
        if (wv.startsWith("$")) {
          wType.setValue("$");
          wVal.setValue(wv.slice(1).trim());
        } else {
          wType.setValue("Unit");
          wVal.setValue(wv);
        }
      } else if (main.startsWith("w/purchase ")) {
        isPurchase.setValue(true);
        wType.setValue("$");
        main = main.slice(11).trimStart();
        const sufIndex = main.indexOf(" ");
        if (sufIndex > 0) {
          wVal.setValue(main.slice(1, sufIndex).trim());
          suffix.setValue(main.slice(sufIndex + 1).trimStart());
        } else {
          wVal.setValue(main.slice(1).trim());
          suffix.setValue("");
        }
      } else {
        suffix.setValue(main.trimStart());
      }
    }
    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-3 mr-2">Save</div>

        {type.value === "$" ? (
          <DecimalInput labeled label="Start Value" placeholder="Value" style={{ width: '96%' }}
            value={start.value}
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(e, end.value, type.value, isPurchase.value, wVal.value, wType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Start Value" placeholder="Value" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={start.value}
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(e, end.value, type.value, isPurchase.value, wVal.value, wType.value, suffix.value);
            }}
          />
        )}

        <div className="mt-3 mx-1">-</div>

        {type.value === "$" ? (
          <DecimalInput labeled label="End Value" placeholder="Value" style={{ width: '96%' }}
            value={end.value}
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(start.value, e, type.value, isPurchase.value, wVal.value, wType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="End Value" placeholder="Value" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={end.value}
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(start.value, e, type.value, isPurchase.value, wVal.value, wType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '94%' }} className="ml-2"
          options={typeData} value={type.value}
          onChange={(e) => {
            const nextStart = e === "$" ? formatDollarValue(start.value) : start.value;
            const nextEnd = e === "$" ? formatDollarValue(end.value) : end.value;
            type.setValue(e);
            start.setValue(nextStart);
            end.setValue(nextEnd);
            handleUpdateValue(nextStart, nextEnd, e, isPurchase.value, wVal.value, wType.value, suffix.value);
          }} />

        <div className="mt-3" style={{ width: '100%', fontSize: 12 }}>
          on next shopping visit
        </div>
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton label="w/purchase" className="mt-3" value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(start.value, end.value, type.value, e, wVal.value, wType.value, suffix.value);
          }}
        />

        {wType.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '94%' }} className="ml-2"
            value={wVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              wVal.setValue(e);
              handleUpdateValue(start.value, end.value, type.value, isPurchase.value, e, wType.value, suffix.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value" style={{ width: '94%' }} className="ml-2"
            allowclear="true" inputType="float" value={wVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              wVal.setValue(e);
              handleUpdateValue(start.value, end.value, type.value, isPurchase.value, e, wType.value, suffix.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '94%' }} className="ml-2"
          options={typeData2} value={wType.value || "Unit"} disabled={!isPurchase.value}
          onChange={(e) => {
            wType.setValue(e);
            handleUpdateValue(start.value, end.value, type.value, isPurchase.value, wVal.value, e, suffix.value);
          }} />

        <LabelledInput label="Suffix" placeholder="Suffix" className="ml-2"
          allowclear="true" value={suffix.value}
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(start.value, end.value, type.value, isPurchase.value, wVal.value, wType.value, e);
          }}
        />
      </div>
    </>
  );
};